import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import styles from "./FooterNew.module.css";
import { useNavigate, useLocation } from "react-router-dom";
import NewModal from "../NewModal/NewModal";
import ConfirmModal from "../ConfirmModal/ConfirmModal";
import useAgentPermissions from "../../hooks/useAgentPermissions";
import { useTeamStore } from "../../Store/teamStore";
import { getActiveOwnerId } from "../../lib/activeContext";
import LockOverlay from "../LockOverlay/LockOverlay";
import detectPlatform from "../../utils/detectPlatform";
import { isMobileAppSurface } from "../../contexts/GlobalCallContext";
import { isPythonBackend, usesElevenLabs } from "../../utils/apiBackend";
import axios from "axios";
import { listAgentsbyUserId, fetchTeamDashboard } from "../../Store/apiStore";
import { SetupProgressRing } from "../SetupProgress/SetupProgress";
import {
    isNativeApp,
    requestNativeDriveConnect,
    DriveConnectResult,
} from "../../utils/nativeDrive";

// On the mobile app these menu actions are paid features — locked on a FREE plan.
const PLAN_GATED_ACTIONS = ["PUBLIC_AGENT", "WIDGET_INSTALL"];

// Actions locked when no phone number is assigned to the agent yet.
const NUMBER_GATED_ACTIONS = [];

// Ye More me edit-agent permission ke bina bhi khulte hain — inki apni permission hai.
const EDIT_EXEMPT_ACTIONS = ["DIALER"];

// More Setting menu ke sections — har ek apni horizontally scrollable row.
const MORE_SECTIONS = [
    {
        key: "agent",
        title: "Agent ",
        actions: [
            "TEST_AGENT",
            "VOICE_LANGUAGE",
            "BUSINESS_DETAILS",
            "KNOWLEDGE_BASE",
            "PUBLIC_AGENT",
            "INTEGRATIONS",
            "SETUP_SCORE",
            "CONNECT_CALENDAR",
            "WIDGET_INSTALL",
            "CONNECT_DRIVE",
        ],
    },
    {
        key: "ops",
        title: "Operations & Management",
        actions: [
            "CALL_SETTING",
            "AGENT_SCHEDULE",
            "LIVE_MONITORING",
            "IMPORT_PHONE",
            "UPGRADE",
            "DIALER",
            "REACTIVATE_SUBSCRIPTION",
            "CANCEL_SUBSCRIPTION",
            "DEACTIVATE",
        ],
    },
    {
        key: "products",
        title: "Rexpt Add-ons",
        actions: ["POUNCE"],
    },
];

const MoreSectionIcon = ({ kind }) => {
    if (kind === "ops") {
        return (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path d="M7.98345 9.35753C8.74234 9.35753 9.35753 8.74234 9.35753 7.98345C9.35753 7.22457 8.74234 6.60938 7.98345 6.60938C7.22457 6.60938 6.60938 7.22457 6.60938 7.98345C6.60938 8.74234 7.22457 9.35753 7.98345 9.35753Z" fill="url(#moreOpsIconInner)" />
                <path d="M15.6399 6.61665L13.7248 6.25438C13.6103 5.86698 13.4558 5.49258 13.2636 5.13724L14.3632 3.511C14.4125 3.43371 14.4347 3.34223 14.4263 3.25093C14.418 3.15964 14.3795 3.07372 14.3169 3.0067L12.946 1.63581C12.8788 1.57575 12.7937 1.53934 12.7038 1.53214C12.6139 1.52493 12.5241 1.54733 12.4481 1.59591L10.8219 2.71305C10.4559 2.51293 10.0696 2.35243 9.66963 2.23428L9.31214 0.319182C9.2912 0.230649 9.24175 0.151451 9.17139 0.0937783C9.10103 0.0361059 9.01366 0.00315592 8.92274 0L6.98371 0C6.89256 0.00234826 6.80479 0.035004 6.73427 0.092807C6.66375 0.15061 6.6145 0.230264 6.59431 0.319182L6.23203 2.25662C5.85152 2.3726 5.48324 2.52547 5.13245 2.71305L3.52696 1.61506C3.44967 1.56576 3.35819 1.54355 3.26689 1.55193C3.1756 1.5603 3.08968 1.5988 3.02266 1.66134L1.65177 3.03223C1.58922 3.09926 1.55073 3.18517 1.54235 3.27647C1.53397 3.36776 1.55618 3.45925 1.60549 3.53654L2.71305 5.1516C2.52569 5.50191 2.37437 5.87032 2.26141 6.25118L0.346313 6.61346C0.252646 6.62998 0.167367 6.67782 0.104449 6.74915C0.0415299 6.82047 0.0047024 6.91106 0 7.00605L0 8.9371C0.00246533 9.02858 0.0351011 9.11668 0.0928281 9.18768C0.150555 9.25868 0.230135 9.30861 0.319182 9.3297L2.23428 9.69197C2.35014 10.0789 2.50466 10.4531 2.69549 10.8091L1.6023 12.405C1.55053 12.4857 1.52844 12.5819 1.53979 12.6771C1.55115 12.7723 1.59525 12.8606 1.66454 12.9269L3.03223 14.2946C3.09884 14.3579 3.18484 14.3969 3.27635 14.4053C3.36786 14.4137 3.45952 14.391 3.53654 14.3409L5.13884 13.2461C5.48468 13.4335 5.84818 13.5864 6.22405 13.7025L6.58792 15.6399C6.60886 15.7285 6.65832 15.8077 6.72868 15.8653C6.79904 15.923 6.8864 15.956 6.97733 15.9591H8.91636C9.00759 15.957 9.0955 15.9245 9.16607 15.8666C9.23665 15.8088 9.28582 15.729 9.30576 15.6399L9.66484 13.7248C10.0578 13.6101 10.438 13.4556 10.7995 13.2636L12.4162 14.3632C12.4938 14.4145 12.5864 14.4382 12.679 14.4304C12.7717 14.4225 12.859 14.3837 12.9269 14.3201L14.2978 12.9492C14.3591 12.882 14.3963 12.7962 14.4035 12.7055C14.4107 12.6148 14.3876 12.5242 14.3377 12.4481L13.2461 10.8362C13.4398 10.4744 13.5975 10.0943 13.7169 9.70155L15.632 9.33927C15.721 9.31819 15.8006 9.26826 15.8583 9.19726C15.916 9.12625 15.9487 9.03816 15.9511 8.94668V7.00924C15.9522 6.91803 15.9219 6.82922 15.8652 6.75773C15.8085 6.68624 15.729 6.63643 15.6399 6.61665ZM7.97956 11.307C7.3212 11.3064 6.67781 11.1106 6.13073 10.7443C5.58365 10.3781 5.15745 9.85782 4.90602 9.24936C4.65459 8.64091 4.58921 7.97156 4.71815 7.32595C4.8471 6.68034 5.16457 6.08746 5.63043 5.62226C6.0963 5.15707 6.68964 4.84045 7.33543 4.71243C7.98123 4.58442 8.65048 4.65076 9.25857 4.90307C9.86667 5.15537 10.3863 5.58232 10.7518 6.12992C11.1172 6.67753 11.3121 7.3212 11.3118 7.97956C11.3118 8.41693 11.2256 8.85001 11.0581 9.25403C10.8906 9.65805 10.645 10.0251 10.3355 10.3341C10.026 10.6432 9.65866 10.8882 9.2544 11.0551C8.85014 11.2221 8.41693 11.3077 7.97956 11.307Z" fill="url(#moreOpsIconOuter)" />
                <defs>
                    <linearGradient id="moreOpsIconInner" x1="7.98345" y1="6.60938" x2="7.98345" y2="9.35753" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#06AD8A" />
                        <stop offset="1" stopColor="#047360" />
                    </linearGradient>
                    <linearGradient id="moreOpsIconOuter" x1="7.97558" y1="0" x2="7.97558" y2="15.9591" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#06AD8A" />
                        <stop offset="1" stopColor="#047360" />
                    </linearGradient>
                </defs>
            </svg>
        );
    }
    if (kind === "products") {
        return (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path d="M16 3.09785C16.0001 2.90349 15.9399 2.71429 15.8284 2.55829C15.7168 2.4023 15.5599 2.28783 15.3809 2.23186L8.49043 0.075018C8.17056 -0.025006 7.82944 -0.025006 7.50957 0.075018L4.50435 1.01513V5.16067L2.91826 5.46983V1.5105L0.612177 2.23366C0.434718 2.29083 0.279537 2.40558 0.169373 2.56109C0.0592082 2.71661 -0.000147412 2.90471 3.43725e-06 3.09785V12.9022C-0.000519609 13.0956 0.058664 13.2841 0.168855 13.44C0.279047 13.5959 0.434434 13.7109 0.612177 13.7681L7.50957 15.925C7.82944 16.025 8.17056 16.025 8.49043 15.925L15.3878 13.7681C15.5656 13.7109 15.721 13.5959 15.8311 13.44C15.9413 13.2841 16.0005 13.0956 16 12.9022V3.09785ZM14.2609 12.2314L8.86957 13.9182V2.0818L14.2609 3.77039V12.2314ZM9.69217 7.36452C9.6797 7.30495 9.6797 7.24329 9.69217 7.18373C9.70428 7.13021 9.72875 7.08056 9.76348 7.0391C9.7957 7.00039 9.84006 6.97477 9.88869 6.96678L11.0574 6.78599L11.5426 5.40655C11.5511 5.38153 11.5628 5.35781 11.5774 5.33604C11.5899 5.31793 11.6052 5.30206 11.6226 5.28904C11.6378 5.27748 11.6549 5.2689 11.673 5.26373C11.6909 5.26025 11.7091 5.26025 11.727 5.26373C11.7458 5.26644 11.764 5.27256 11.7809 5.2818C11.7994 5.29174 11.8164 5.30454 11.8313 5.31977C11.8482 5.337 11.8628 5.35645 11.8748 5.37762C11.8886 5.40216 11.8997 5.42824 11.9078 5.45536L12.3565 6.8565L13.2939 7.1096C13.331 7.12058 13.363 7.14494 13.3843 7.1783C13.4092 7.21583 13.4264 7.2583 13.4348 7.30305C13.4431 7.35209 13.4431 7.40226 13.4348 7.4513C13.4284 7.49968 13.4117 7.54598 13.3861 7.58689L12.7235 8.60836L12.8835 10.0547C12.8899 10.0978 12.8899 10.1417 12.8835 10.1849C12.8763 10.2235 12.8634 10.2607 12.8452 10.2951C12.8295 10.3256 12.8082 10.3526 12.7826 10.3747C12.7609 10.394 12.7344 10.4066 12.7061 10.4109H12.6957H12.673H12.6504L12.6278 10.3982L11.7339 9.78531L10.7583 10.626L10.7322 10.6459L10.7061 10.6603L10.68 10.6712H10.6539C10.6216 10.6744 10.5891 10.6681 10.56 10.6531C10.5294 10.6363 10.5032 10.6121 10.4835 10.5826C10.4601 10.5484 10.4436 10.5097 10.4348 10.4687C10.4266 10.4209 10.4266 10.3719 10.4348 10.3241L10.6348 8.69695L9.76522 7.54531C9.72532 7.49319 9.70004 7.43063 9.69217 7.36452Z" fill="#2C7EFD" />
            </svg>
        );
    }
    return (
        <svg width="14" height="16" viewBox="0 0 14 16" fill="none" aria-hidden="true">
            <path d="M10.9814 3.9305C10.9814 6.10135 9.19885 7.86099 6.99991 7.86099C4.80097 7.86099 3.01842 6.10128 3.01842 3.9305C3.01912 1.75965 4.80167 0 6.99991 0C9.19893 0 10.9814 1.75972 10.9814 3.9305ZM13.9859 14.909C13.4267 11.7826 10.506 9.40073 6.99505 9.40073C3.4834 9.40073 0.571066 11.7826 0.0138833 14.9097C-0.0881185 15.4812 0.38601 16 0.974095 16H13.0257C13.6145 16 14.0886 15.4812 13.9859 14.909Z" fill="url(#moreAgentIcon)" />
            <defs>
                <linearGradient id="moreAgentIcon" x1="7" y1="0" x2="7" y2="16" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#6B2DEC" />
                    <stop offset="1" stopColor="#581AFF" />
                </linearGradient>
            </defs>
        </svg>
    );
};

const FooterNew = ({
    agentData,
    onTestCall,
    onAssignNumber,
    // Dashboard actions migrated into the More menu (only wired by FastAgentDetails).
    onUpgrade,
    onDelete,
    onDeactivate,
    onTogglePayg,
    isPaygActive = false,
    paygStatusLoading = false,
    /*
     * Cancel Subscription replaces the PAYG entry in the More menu.
     * Wired only by FastAgentDetails; other hosts pass nothing and
     * the option silently doesn't render. Free / demo agents must
     * not see this — those plans have no subscription to cancel.
     */
    onCancelSubscription,
    showUsageBilling = false,
    // Shown instead of Cancel Subscription once the plan is cancelled and can be brought back.
    onReactivateSubscription,
    /*
     * A cancellation is already scheduled for this agent's subscription.
     *
     * The entry stays VISIBLE but locked — the user has a subscription, it is
     * simply already cancelled, so hiding the row would just look like the
     * option vanished. It unlocks by itself once a new active subscription
     * exists, because the host derives this from the live subscription record.
     *
     * Optional: hosts that pass nothing keep the entry fully enabled.
     */
    cancelSubscriptionLocked = false,
    cancelSubscriptionLockMessage = "Your subscription is already cancelled.",
    // QR-I467: Law Firm agent without Google Drive → Test Agent + Widget Install stay locked.
    driveLocked = false,
    driveLockMessage = "Connect Google Drive to use this.",
    /*
     * Once FastAgentDetails retires the on-page setup bar (first-week window
     * over, or agent deactivated / subscription cancelled), it asks this menu to
     * surface a "Setup Score" entry in its place — row 1, position 2.
     * `onSetupScore` is the same routing callback the retired on-page Continue
     * button used. Every other host passes nothing and the entry never renders.
     */
    showSetupScoreEntry = false,
    onSetupScore,
    setupScorePercent = 0,
    /*
     * Fired after this menu connects Drive through the NATIVE bridge. That path
     * has no page redirect, so nothing else re-checks Drive status — the host
     * must be told or its lock overlays stay locked until a reload. Optional:
     * Calendar renders this footer too and has nothing to sync.
     */
    onDriveStatusChange,
}) => {
    const [activeTab, setActiveTab] = useState("home");
    const [isMoreOpen, setIsMoreOpen] = useState(false);
    // Mobile-only: hide the footer while scrolling down, reveal on scroll up.
    const [hideFooter, setHideFooter] = useState(false);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    // null = not checked yet (never gate on it), true/false = checked.
    const [driveConnected, setDriveConnected] = useState(null);
    const [driveLoading, setDriveLoading] = useState(false);
    const [showDisconnectConfirm, setShowDisconnectConfirm] = useState(false);
    // Pounce tile → "existing ya naya business?" sheet.
    const [showPounceChoice, setShowPounceChoice] = useState(false);
    // Drops the native Drive listener if this footer unmounts mid-flow.
    const driveCleanupRef = useRef(null);
    useEffect(() => () => driveCleanupRef.current?.(), []);
    const navigate = useNavigate();
    const location = useLocation();
    // Dashboard is deprecated — kept the variable name to limit refactor blast radius,
    // but the gating no longer matches /dashboard since that route is gone.
    const isDashboard = location.pathname === "/dashboard";
    // Multi-owner: resolve permissions for THIS agent's owner. The agent record
    // carries its owner (`userId`); prefer it so a footer shown on a specific
    // agent reflects THAT agent's owner, not a stale session hint.
    const currentAgentOwnerId = agentData?.agent?.userId || null;
    const selectedOwnerId =
        currentAgentOwnerId ||
        (typeof window !== "undefined" &&
            (sessionStorage.getItem("SelectAgentOwnerId") ||
                localStorage.getItem("teamOwnerId"))) ||
        undefined;
    const { canViewAppointments, canViewContacts, canEditAgents, canAccessDialer, isTeamMember, role } =
        useAgentPermissions(selectedOwnerId);

    const teams = useTeamStore((s) => s.teams);
    const loadTeams = useTeamStore((s) => s.loadTeams);
    useEffect(() => {
        if (isTeamMember) loadTeams();
    }, [isTeamMember, loadTeams]);
    const adminsAnyCompany = (teams || []).some((t) => t.role === "admin");
    // Sirf jis business me login hai usi ka contacts access dekho.
    const activeOwnerId = getActiveOwnerId();
    const contactsActiveCompany = (teams || []).some(
        (t) => t.ownerId === activeOwnerId && (t.role === "admin" || t.permissions?.viewContacts)
    );
    const canOpenContacts = !isTeamMember
        ? true
        : currentAgentOwnerId
            ? canViewContacts
            : contactsActiveCompany;
    useEffect(() => {
        if (location.pathname.includes("/fast-agent-detail")) setActiveTab("home");
        else if (location.pathname.includes("/calendar")) setActiveTab("calendar");
        else if (location.pathname.includes("/contacts")) setActiveTab("contacts");
        // else if (location.pathname.includes("/totalcall-list")) setActiveTab("info");

    }, [location.pathname]);
    /*
     * Hide-on-scroll (mobile only). Scrolling down past a small threshold
     * hides the fixed footer; scrolling up (or reaching the top) reveals it.
     * The width guard keeps desktop/tablet untouched — the listener bails
     * out and the footer stays visible above 768px.
     */
    useEffect(() => {
        const MOBILE_BREAKPOINT = 768;
        const THRESHOLD = 8; // ignore tiny jitters
        let lastScrollY = null;

        const handleScroll = (e) => {
            if (window.innerWidth > MOBILE_BREAKPOINT) {
                setHideFooter(false);
                return;
            }

            /*
             * The page doesn't scroll on `window` — the real scroll happens on
             * an inner container. Listening in the capture phase lets us catch
             * the scroll from whichever element is actually scrolling, and we
             * read the position straight off that element (falling back to the
             * document for full-page scroll).
             */
            const target = e.target;
            const currentY =
                target === document || target === document.documentElement || target === document.body
                    ? window.scrollY || document.documentElement.scrollTop
                    : target.scrollTop;

            if (lastScrollY === null) {
                lastScrollY = currentY;
                return;
            }

            const delta = currentY - lastScrollY;
            if (Math.abs(delta) < THRESHOLD) return;

            // Never hide when near the very top of the container.
            if (delta > 0 && currentY > 10) {
                setHideFooter(true); // scrolling down
            } else if (delta < 0) {
                setHideFooter(false); // scrolling up
            }
            lastScrollY = currentY;
        };

        // capture:true so we hear scroll events from any nested scroll container.
        window.addEventListener("scroll", handleScroll, { passive: true, capture: true });
        return () => window.removeEventListener("scroll", handleScroll, { capture: true });
    }, []);

    const userId = agentData?.agent?.userId;
    const agentId = agentData?.agent?.agent_id;

    /*
     * Multi-agent detection — drives the Home button's destination.
     *
     *   - 1 agent: Home → /fast-agent-detail (current behaviour). Single
     *     agent users never need the picker; a click while ON fast-agent
     *     -detail is effectively a no-op.
     *   - 2+ agents: Home → /dashboard. The picker is the natural "back"
     *     surface; previously these users had no way to switch between
     *     their agents from the footer.
     *
     * Fetched once on mount per userId. The endpoint is cheap (count
     * only) and we skip the call entirely when there's no userId (e.g.
     * footer rendered on an anonymous page).
     */
    const [agentCount, setAgentCount] = useState(0);
    // Account ke agents me Outbound Caller (Pounce) agent hai ya nahi. Ban
    // chuka ho to More me "Outbound Caller" tile nahi. null = abhi pata nahi
    // (tab tak tile chhupi).
    const [hasPounceAgent, setHasPounceAgent] = useState(null);
    useEffect(() => {
        if (!userId) return;
        let cancelled = false;
        (async () => {
            try {
                // Team members can be linked to several owners. Count the
                // aggregate accessible list, not just the currently-open
                // agent's owner, so Home opens the picker only for 2+ agents.
                const agents = isTeamMember
                    ? (await fetchTeamDashboard())?.agents || []
                    : await listAgentsbyUserId(userId);
                if (cancelled) return;
                setAgentCount(agents.length);
                // Team list kai owners ki hoti hai — sirf isi owner ke agents dekho.
                setHasPounceAgent(
                    agents.some(
                        (a) =>
                            (!a?.userId || a.userId === userId) &&
                            String(a?.agentRole || a?.role || "").toLowerCase() === "pounce"
                    )
                );
            } catch (err) {
                // Check fail → tile dikhne do; purana behaviour.
                if (!cancelled) setHasPounceAgent(false);
                // Soft-fail — leave count at 0 so Home falls back to the
                // original /fast-agent-detail target instead of breaking.
                console.warn(
                    "[FooterNew] agent count check failed:",
                    err?.message || err,
                );
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [userId, isTeamMember]);
    const getVoipNumbers = (v) => {
        if (!v) return [];
        if (Array.isArray(v)) return v.filter(Boolean);

        if (typeof v === "string") {
            try {
                const parsed = JSON.parse(v);
                return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
            } catch {
                return v.trim() ? [v.trim()] : [];
            }
        }
        return [];
    };
    const checkDriveStatus = useCallback(async () => {
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/is-drive-connected`,
                { userId, agentId },
            );
            setDriveConnected(res.data?.connected || false);
        } catch (err) {
            console.error("Drive status check failed:", err);
            setDriveConnected(false);
        }
    }, [userId, agentId]);
    // console.log(agentData?.agent?.business?.businessType, "business type")

    // console.log(agentData?.agent, "agent data")
    // console.log(driveConnected, "drive connected")
    const isLawFirmAgent = agentData?.business?.businessType === "Law Firm";
    // console.log(isLawFirmAgent, "is law firm agent")
    useEffect(() => {
        if (isMoreOpen && userId && agentId && isLawFirmAgent) {
            checkDriveStatus();
        }
    }, [isMoreOpen, checkDriveStatus, isLawFirmAgent]);


    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get("drive") === "connected" && isLawFirmAgent) {
            checkDriveStatus();
            navigate(location.pathname, { replace: true });
        }
    }, [location.search, isLawFirmAgent]);

    //   const checkDriveStatus = async () => {
    //     try {
    //       // ✅ FIX 1 — agentId bhi bheja
    //       const res = await axios.post(
    //         `${process.env.REACT_APP_API_BASE_URL}/is-drive-connected`,
    //         { userId, agentId },
    //       );
    //       // ✅ FIX 4 — driveConnected field (connected nahi)
    //       setDriveConnected(res.data?.driveConnected || false);
    //     } catch (err) {
    //       console.error("Drive status check failed:", err);
    //       setDriveConnected(false);
    //     }
    //   };


    /*
     * Connect Drive sends the user to Google via a full-page redirect. If they
     * come back WITHOUT finishing (browser back / cancel), the page is restored
     * from the bfcache with its old JS state — so `driveLoading` was still true
     * and the tile sat on "Connecting…" forever, unclickable.
     *
     * Reset it whenever the page is shown again. Same recipe SyncDialog already
     * uses for the contacts OAuth round-trip.
     */
    useEffect(() => {
        if (!driveLoading) return;

        const clearStaleLoading = () => setDriveLoading(false);
        const handleVisibility = () => {
            if (document.visibilityState === "visible") clearStaleLoading();
        };
        // pageshow with persisted=true == restored from the back-forward cache
        const handlePageShow = (e) => {
            if (e.persisted) clearStaleLoading();
        };

        document.addEventListener("visibilitychange", handleVisibility);
        window.addEventListener("pageshow", handlePageShow);
        return () => {
            document.removeEventListener("visibilitychange", handleVisibility);
            window.removeEventListener("pageshow", handlePageShow);
        };
    }, [driveLoading]);

    const handleConnectDrive = async () => {
        if (!userId || !agentId) {
            console.error("userId or agentId missing");
            return;
        }

        setDriveLoading(true);
        setIsMoreOpen(false);

        // ── Inside the RN app: the native shell owns the whole connect ────
        // Google blocks its OAuth screen inside a WebView (403
        // disallowed_useragent), so the web side can't run the consent here.
        // We use the same CONNECT_DRIVE bridge as ConnectDrivePopup: native
        // runs the Google sheet, gets the serverAuthCode, and posts it to the
        // backend's mobile branch itself. Plain web is untouched below.
        if (isNativeApp()) {
            const reply = await requestNativeDriveConnect(
                userId,
                agentId,
                (fn) => { driveCleanupRef.current = fn; },
            );
            driveCleanupRef.current = null;
            setDriveLoading(false);

            if (reply.type === DriveConnectResult.CONNECTED) {
                setDriveConnected(true);
                // No redirect on this path, so the page never re-checks Drive
                // on its own — tell it, or its lock overlays stay on.
                onDriveStatusChange?.();
                return;
            }
            // Cancelled = user's own choice. Errors are logged like below —
            // this tile has no error surface of its own.
            if (reply.type === DriveConnectResult.ERROR) {
                console.error("Drive connect failed:", reply?.data?.message);
            }
            return;
        }

        try {
            const res = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/connect-drive`,
                // Send the current domain so the OAuth callback returns the user
                // here (same as Calendar / Google login), not the default domain.
                { userId, agentId, origin: window.location.origin },
            );

            if (res.data?.alreadyConnected) {
                // ✅ Token already tha — folder seedha ban gaya, Google screen nahi aayi
                setDriveConnected(true);
                setDriveLoading(false);
                return;
            }

            if (res.data?.authUrl) {
                // 🔐 Pehli baar — Google consent screen
                window.location.href = res.data.authUrl;
            }
        } catch (err) {
            console.error("Drive connect failed:", err);
            setDriveLoading(false);
        }
    };

    const handleDisconnectDrive = async () => {
        if (!userId) return;
        setDriveLoading(true);

        try {
            // ✅ FIX 2 — /api/ double nahi
            await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/disconnect-drive`,
                { userId },
            );
            setDriveConnected(false);
            setShowDisconnectConfirm(false);
        } catch (err) {
            console.error("Drive disconnect failed:", err);
        } finally {
            setDriveLoading(false);
        }
    };
    const voipNumbersArr = useMemo(
        () => getVoipNumbers(agentData?.agent?.voip_numbers),
        [agentData?.agent?.voip_numbers]
    );

    const hasVoipNumbers = voipNumbersArr.length > 0;

    // Python agents can't use the Retell-only entries below (Pounce, Live
    // Monitoring, Import Number, Dialer). Call Setting and Integrations are shown:
    // Node saves a Python agent's call settings to its row and the Python
    // pipeline applies them on every call, and MCP / Zapier / HubSpot / Make
    // tools run for Python calls and chats.
    const isPython = isPythonBackend();

    /*
     * Dialer sirf un numbers pe chalta hai jo hamare app se liye gaye hain
     * (voip_number_provider me in_app_purchase: true). Backend bhi thik yahi
     * filter lagata hai, isliye dono ek jaisa behave karte hain.
     *
     * Purani rows me abhi meta nahi hai — unpe voip_numbers hi dekh lete hain,
     * warna un users se dialer chhup jaata jinke paas number pehle se hai.
     */
    const hasDialableNumber = useMemo(() => {
        let meta = agentData?.agent?.voip_number_provider;
        if (typeof meta === "string") {
            try {
                meta = JSON.parse(meta);
            } catch {
                meta = null;
            }
        }
        if (Array.isArray(meta) && meta.length) {
            return meta.some(
                (e) =>
                    e &&
                    e.in_app_purchase !== false &&
                    (e.provider || "telnyx") === "telnyx"
            );
        }
        return voipNumbersArr.length > 0;
    }, [agentData?.agent?.voip_number_provider, voipNumbersArr]);

    // Dialer sirf SMB plans pe — Starter / Scaler / Growth. Baaki sab (free,
    // demo, PAYG, blank) ke liye entry hi nahi banti. DB me naam alag-alag case
    // me aata hai, isliye trim+lowercase karke compare — wahi RecommendedPlan ke
    // PLAN_DEFS aur FastAgentDetails ke isPaidSmbPlan me hota hai.
    const dialerPlan = String(agentData?.agent?.agentPlan || "").trim().toLowerCase();
    const isSmbPlan = ["starter", "scaler", "growth"].includes(dialerPlan);
    const isPaidAgent = ["starter", "scaler", "growth", "payg", "pay-as-you-go", "appsumo"].includes(dialerPlan) || (Boolean(dialerPlan) && dialerPlan !== "free" && dialerPlan !== "demo");

    // Number chahiye, owner ki dialer permission chahiye, aur plan SMB ho.
    const canUseDialer = hasDialableNumber && canAccessDialer && isSmbPlan;

    // options list (same UI, just click actions added)
    const baseOptions = [
        { label: "Test Agent", icon: `${agentData?.agent?.avatar}`, action: "TEST_AGENT", isDefault: true },
        // Row 1, position 2 — the retired setup bar's replacement.
        // Only present once the host (FastAgentDetails) turns it on.
        ...(showSetupScoreEntry
            ? [{ label: "Setup Score", action: "SETUP_SCORE" }]
            : []),
        { label: "Call Setting", icon: "/svg/call_setting_icon.svg", action: "CALL_SETTING" },
        { label: "Connect Calendar", icon: "/svg/connect_calendar_icon.svg", action: "CONNECT_CALENDAR" },
        { label: "Public Agent", icon: "/svg/agent_schedule_icon.svg", action: "PUBLIC_AGENT", isNew: true },
        { label: "Agent Schedule", icon: "/svg/agent_schedule_icon.svg", action: "AGENT_SCHEDULE" },
        { label: "Knowledge Base", icon: "/svg/knowledge_base_icon.svg", action: "KNOWLEDGE_BASE" },
        { label: "Voice & language", icon: "/svg/mic_icon.svg", action: "VOICE_LANGUAGE" },
        { label: "Widget Install", icon: "/svg/widget_icon.svg", action: "WIDGET_INSTALL", isNew: true },
        { label: "Integrations", icon: "/svg/Integration-New2.svg", action: "INTEGRATIONS", isNew: true }
        // { label: "Integrations", icon: "/svg/Integration-New2.svg", aictiomn: "INTEGRATIONS", isNew: true }
        ,
        { label: "Business Details", icon: "/svg/business_icon.svg", action: "BUSINESS_DETAILS" },
        // Pounce (speed-to-lead) Retell outbound pe chalta hai — Python agent
        // ke paas wo hai nahi, aur sirf paid agents ko dikhana hai. Jiska
        // Pounce agent pehle se bana hai use dobara nahi.
        // Pounce agent pehle se bana hai useee dobara nahi.
        // New .ai (ElevenLabs) accounts get it too: their Pounce agent is still
        // built on Node/Retell (BusinessStep.agentOnPython). India stays out —
        // Pounce dials US numbers.
        ...((!isPython || usesElevenLabs()) && isPaidAgent && hasPounceAgent === false
            ? [{ label: "Outbound Caller", subtitle: "AI outbound calling", icon: "/svg/outbound_caller_icon.svg", action: "POUNCE", isPremium: true }]
            : []),
        // Sirf account owner ko — team ke admin/support ko live call sunne nahi dena.
        // Python backend pe live monitoring hai hi nahi (Retell/Node ka feature).
        ...(role === "owner" && !isPython
            ? [{ label: "Live Monitoring", icon: "/svg/eye-svg.svg", action: "LIVE_MONITORING", isNew: true }]
            : []),

        // Dialer aur Import Number (Twilio) abhi Indian / Python users ko nahi dene.
        ...(canUseDialer && !isPython
            ? [{ label: "Dialer", icon: "/svg/dialer_icon.svg", action: "DIALER", isNew: true }]
            : []),
        ...(isPython
            ? []
            : [{ label: "Import Number", icon: "/svg/import-sip-ph.svg", action: "IMPORT_PHONE", isNew: true }]),
        ...(isLawFirmAgent
            ? [{
                // ✅ Label loading state ke hisaab se change hoga
                label: driveLoading
                    ? "Connecting..."
                    : driveConnected
                        ? "Drive Connected"
                        : "Connect Drive",
                icon: "/svg/google-drive.svg",
                action: "CONNECT_DRIVE",
                isDriveConnected: driveConnected,
            }]
            : []),
    ];

    // Dashboard actions injected only when the parent passes the handlers
    // (FastAgentDetails). Other screens that reuse FooterNew won't see them.
    // Icons and labels swap based on current state, mirroring Dashboard.
    const dashboardActions = [];
    /*
     * "Upgrade Agent" menu entry — hidden per product decision. Keeping the
     * block (commented, not deleted) so it can be quickly re-enabled later.
     */
    // if (typeof onUpgrade === "function") {
    //     dashboardActions.push({
    //         label: "Upgrade Agent",
    //         icon: "/svg/Upgrade.svg",
    //         action: "UPGRADE",
    //     });
    // }
    /*
     * PAYG menu entry — commented out per product decision; replaced
     * by Cancel Subscription below. Keeping the block (not deleting)
     * so we can quickly re-enable if PAYG returns to the menu.
     */
    // if (typeof onTogglePayg === "function") {
    //     dashboardActions.push({
    //         label: paygStatusLoading ? "Loading..." : "PAYG",
    //         icon: "/svg/pagy.svg",
    //         action: "TOGGLE_PAYG",
    //         statusTag: isPaygActive ? "On" : "Off",
    //         statusType: isPaygActive ? "on" : "off",
    //     });
    // }
    /*
     * Cancel Subscription — only added when the host wires the
     * callback. FastAgentDetails additionally gates the prop on
     * agent.agentPlan !== "free" / "demo" so this never reaches a
     * free-tier user. Keeping the visibility gate up-stream (in
     * FastAgentDetails) instead of duplicating the plan check here
     * avoids a stale-prop scenario where FooterNew thinks a free
     * agent has a sub.
     */
    if (typeof onReactivateSubscription === "function") {
        dashboardActions.push({
            label: "Reactivate Subscription",
            icon: "/svg/pagy.svg",
            action: "REACTIVATE_SUBSCRIPTION",
        });
    } else if (typeof onCancelSubscription === "function") {
        dashboardActions.push({
            label: "Cancel Subscription",
            icon: "/svg/pagy.svg",
            action: "CANCEL_SUBSCRIPTION",
        });
    }
    // Usage & Billing — only for paid/PAYG agents (parent decides via showUsageBilling).
    // Apna alag icon (Usage-Billing-icon.svg) — pehle pagy.svg tha, jo Cancel
    // Subscription wala hi tha, to dono tile ek jaise dikhte the. payg_icon.svg
    // nahi: wo Usage tab card ka GREEN tag hai, is purple menu me alag lagta.
    if (showUsageBilling) {
        dashboardActions.push({
            label: "Usage & Billing",
            icon: "/svg/Usage-Billing-icon.svg",
            action: "USAGE_BILLING",
        });
    }
    if (typeof onDeactivate === "function") {
        // Truthy check — Sequelize can return BOOLEAN columns as either 1/0
        // or true/false depending on the query path, so === 1 alone misses
        // some cases.
        const isAgentDeactivated = !!agentData?.agent?.isDeactivated;
        dashboardActions.push({
            label: isAgentDeactivated ? "Activate Agent" : "Deactivate Agent",
            icon: isAgentDeactivated
                ? "/svg/activate_agent.svg"
                : "/svg/deactivate_agent.svg",
            action: "DEACTIVATE",
        });
    }
    /*
     * Delete Agent — commented out per product decision; the entry no
     * longer appears in the More menu. Keeping the block (not deleting)
     * so it can be quickly re-enabled. The DELETE case in the handler and
     * the onDelete prop from FastAgentDetails are left intact.
     */
    // if (typeof onDelete === "function") {
    //     dashboardActions.push({
    //         label: "Delete Agent",
    //         icon: "/svg/delete_agent.svg",
    //         action: "DELETE",
    //     });
    // }
    const options = [...baseOptions, ...dashboardActions];

    // More Setting ke teen sections. `actions` ka order hi row ka order hai.
    // `index` options wala hi rakha hai — hover highlight usi se chalta hai.
    // Jo action kisi list me nahi (kal koi naya jud jaaye) wo Operations ke
    // aakhir me girta hai, menu se gayab nahi hota.
    const indexedOptions = options.map((item, index) => ({ item, index }));
    const listedActions = MORE_SECTIONS.flatMap((s) => s.actions);
    const moreSections = MORE_SECTIONS.map((section) => ({
        ...section,
        items: [
            ...section.actions
                .map((action) => indexedOptions.find((o) => o.item.action === action))
                .filter(Boolean),
            ...(section.key === "ops"
                ? indexedOptions.filter((o) => !listedActions.includes(o.item.action))
                : []),
        ],
    })).filter((section) => section.items.length > 0);

    const handleTabClick = (tab, path) => {
        setActiveTab(tab);
        navigate(path);
    };

    // Drive-gated actions — only the test call. Widget install stays open.
    /*
     * A Law-Firm agent cannot serve calls until Drive is connected (recordings
     * and transcripts have nowhere to land), so everything that EXPOSES the
     * agent to callers stays locked until then — not just the test call.
     *
     * Public Agent and Widget Install were missing here: both publish the agent
     * to real callers, which is exactly what the Drive gate is meant to prevent
     * while it can't record. Test Agent alone left two open doors.
     */
    const DRIVE_GATED_ACTIONS = ["TEST_AGENT", "PUBLIC_AGENT", "WIDGET_INSTALL"];
    // Parent's flag when it has one (FastAgentDetails), else our own check —
    // FooterNew also renders on screens that don't compute it.
    // Drive lock is a LAW-FIRM-ONLY gate. The whole thing is scoped to
    // isLawFirmAgent so the parent's `driveLocked` prop can never lock (show
    // "Connect Drive") for a non-Law-Firm category (e.g. Real Estate Broker).
    // Parent's flag when it has one (FastAgentDetails), else our own check.
    //
    // Live had `driveLocked || (isLawFirmAgent && ...)`, which let the parent
    // flag lock ANY category. That relied on FastAgentDetails never setting it
    // for a non-Law-Firm agent — an implicit contract, and now a costlier one
    // to break since this gate covers three menu items instead of one.
    const isDriveLocked =
        isLawFirmAgent && (driveLocked || driveConnected === false);

    // Andar khulne layak kuch bacha hi nahi — tab poore grid par ek hi taala.
    const lockWholeGrid = !canEditAgents && !canUseDialer;

    // App surface (now web too) + FREE (non-paid) agent → Public Agent / Widget
    // Install locked.
    const _isMobile = isMobileAppSurface();
    const _planLower = String(agentData?.agent?.agentPlan || "").trim().toLowerCase();
    // "appsumo" counts as paid: that lifetime deal was bought on AppSumo's
    // checkout rather than ours, so the account has paid even though it holds
    // no subscription of ours.
    const _isPaidPlan = ["starter", "scaler", "growth", "payg", "pay-as-you-go", "appsumo"].includes(_planLower);
    /*
     * NUMBER ASSIGN ho chuka hai to lock nahi.
     *
     * Pehle gate sirf plan dekhta tha. A/B variant B me user ko number PAYMENT
     * SE PEHLE milta hai (/receptionist-number pe), to plan "free" rehte hue bhi
     * uske paas asli business number hota hai — aur usse Public Agent / Widget
     * Install pe taala dikhta tha, jo galat hai: number hai to wo use publish
     * kar hi sakta hai.
     *
     * A flow me ye branch farq nahi karti — wahan number milta hi payment ke
     * baad hai, aur tab plan paid ho chuka hota hai.
     */
    const _hasAssignedNumber = (() => {
        const v = agentData?.agent?.voip_numbers;
        if (!v) return false;
        if (Array.isArray(v)) return !!v[0];
        if (typeof v === "string") {
            const t = v.trim();
            if (!t || t === "[]" || t === "null") return false;
            if (t.startsWith("[")) {
                try {
                    const parsed = JSON.parse(t);
                    return Array.isArray(parsed) ? !!parsed[0] : !!parsed;
                } catch {
                    return true;
                }
            }
            return true;
        }
        return false;
    })();
    const isMobileFree = _isMobile && !_isPaidPlan && !_hasAssignedNumber;

    const handleOptionClick = (action) => {
        if (isDriveLocked && DRIVE_GATED_ACTIONS.includes(action)) return;
        if (isMobileFree && PLAN_GATED_ACTIONS.includes(action)) return;
        if (!_hasAssignedNumber && NUMBER_GATED_ACTIONS.includes(action)) return;
        // Overlay to click rokta hi hai, ye keyboard/Enter wala raasta band karta hai.
        if (!canEditAgents && !EDIT_EXEMPT_ACTIONS.includes(action)) return;
        // Guarded here as well as in the overlay: the tile is also reachable by
        // keyboard (Enter / Space), which does not go through LockOverlay.
        if (cancelSubscriptionLocked && action === "CANCEL_SUBSCRIPTION") return;

        switch (action) {
            case "TEST_AGENT":
                setIsMoreOpen(false);
                onTestCall?.();
                return;

            case "SETUP_SCORE":
                // Retired setup bar: mirror the former on-page Continue button's
                // routing. Keep a direct-route fallback for FooterNew hosts that
                // do not provide the callback.
                setIsMoreOpen(false);
                if (typeof onSetupScore === "function") {
                    onSetupScore();
                    return;
                }
                navigate("/setup-ready", {
                    state: {
                        agentId: agentData?.agent?.agent_id,
                        bussinesId: agentData?.agent?.businessId,
                    },
                });
                return;

            case "CALL_SETTING":
                setIsMoreOpen(false);
                navigate("/call-setting", {
                    state: {
                        selectedAgentname: `${agentData?.agent?.agentName}-${agentData?.agent?.agentCode}`,
                        fromPage: "dashboard",
                        agentId: agentData?.agent?.agent_id,
                        businessId: agentData?.agent?.businessId
                    },
                })
                return;

            case "CONNECT_CALENDAR":
                setIsMoreOpen(false);
                // Name the agent this footer belongs to; otherwise the screen
                // falls back to whichever agent was opened last.
                navigate("/connect-calender2", {
                    state: agentId
                        ? { agentId, bussinesId: agentData?.agent?.businessId }
                        : undefined,
                });
                return;

            // Usage & Billing — pass agentId so /usage-history can fetch that agent's data.
            case "USAGE_BILLING":
                setIsMoreOpen(false);
                sessionStorage.setItem("SelectAgentId", agentData?.agent?.agent_id || "");
                navigate("/usage-history", {
                    state: { agentId: agentData?.agent?.agent_id },
                });
                return;

            case "PUBLIC_AGENT":
                setIsMoreOpen(false);
                sessionStorage.setItem("SelectAgentId", agentData?.agent?.agent_id);
                sessionStorage.setItem("SelectAgentBusinessId", agentData?.agent?.businessId || "");
                navigate("/public-agent-availability", {
                    state: {
                        agentId: agentData?.agent?.agent_id,
                        businessId: agentData?.agent?.businessId,
                    },
                });
                return;

            case "AGENT_SCHEDULE":
                setIsMoreOpen(false);
                navigate('/Business_hours', {
                    state: { agentId: agentData?.agent?.businessId },
                });
                return;

            case "KNOWLEDGE_BASE":
                setIsMoreOpen(false);
                navigate("/add-file", {
                    state: {
                        agent_id: agentData?.agent?.agent_id,
                        knowledgeBaseId: agentData?.agent?.knowledgeBaseId,
                    },
                });
                return;

            case "VOICE_LANGUAGE":
                setIsMoreOpen(false);
                sessionStorage.setItem("naviateFrom", "editAgent");
                sessionStorage.setItem(
                    "SelectAgentBusinessId",
                    agentData?.agent?.businessId
                );
                sessionStorage.setItem(
                    "SelectAgentId",
                    agentData?.agent?.agent_id
                );
                navigate("/edit-language", {
                    state: {
                        agentId: agentData?.agent?.agent_id,
                        businessId: agentData?.agent?.businessId,
                    },
                });
                return;

            case "WIDGET_INSTALL":
                setIsMoreOpen(false);
                // if (!hasVoipNumbers) {
                //     onAssignNumber?.();
                //     return;
                // }
                navigate("/integrate-agent", {
                    state: {
                        agentDetails: agentData?.agent,
                    },
                });
                return;

            case "INTEGRATIONS":
                setIsMoreOpen(false);
                navigate("/integrations", {
                    state: {
                        agentId: agentData?.agent?.agent_id,
                        businessId: agentData?.agent?.businessId,
                    },
                });
                return;
                  case "LIVE_MONITORING":
                setIsMoreOpen(false);
                navigate("/live-monitoring/active-calls");
                return;

            case "BUSINESS_DETAILS":
                setIsMoreOpen(false);
                sessionStorage.setItem("naviateFrom", "editAgent");
                sessionStorage.setItem(
                    "SelectAgentBusinessId",
                    agentData?.agent?.businessId
                );
                sessionStorage.setItem(
                    "SelectAgentId",
                    agentData?.agent?.agent_id
                );
                navigate("/editBusinessDetails", {
                    state: {
                        agentId: agentData?.agent?.agent_id,
                        businessId: agentData?.agent?.businessId,
                    },
                });
                return;
            case "POUNCE":
                setIsMoreOpen(false);
                setShowPounceChoice(true);
                return;

            case "DIALER":
                setIsMoreOpen(false);
                // Agent carried through so the dialer knows whose number to call from.
                sessionStorage.setItem("SelectAgentId", agentData?.agent?.agent_id || "");
                navigate("/dialer", {
                    state: {
                        agentId: agentData?.agent?.agent_id,
                        agentName: agentData?.agent?.agentName,
                        businessId: agentData?.agent?.businessId,
                    },
                });
                return;


                 case "IMPORT_PHONE":{
                setIsMoreOpen(false);
                // Carry the agent through so the import screen can bind in one shot.
               // agentId rides in the URL, not router state — state is lost on refresh,
                // which would drop the lock and hand an admin the full agent picker.
                const importAgentId = agentData?.agent?.agent_id || "";
                navigate(
                    `/import-phone${importAgentId ? `?agentId=${encodeURIComponent(importAgentId)}` : ""}`,
                    {
                        state: {
                            agentId: importAgentId,
                            agentName: agentData?.agent?.agentName,
                            businessId: agentData?.agent?.businessId,
                        },
                    }
                );
                return;
            }
               
            case "CONNECT_DRIVE":
                if (driveLoading) return; // Loading mein kuch mat karo
                if (driveConnected) {
                    setIsMoreOpen(false);
                    setShowDisconnectConfirm(true);
                } else {
                    handleConnectDrive();
                }
                return;

            case "UPGRADE":
                setIsMoreOpen(false);
                onUpgrade?.();
                return;

            case "DELETE":
                setIsMoreOpen(false);
                onDelete?.();
                return;

            case "DEACTIVATE":
                setIsMoreOpen(false);
                onDeactivate?.();
                return;

            case "TOGGLE_PAYG":
                setIsMoreOpen(false);
                onTogglePayg?.();
                return;

            case "CANCEL_SUBSCRIPTION":
                setIsMoreOpen(false);
                onCancelSubscription?.();
                return;

            case "REACTIVATE_SUBSCRIPTION":
                setIsMoreOpen(false);
                onReactivateSubscription?.();
                return;

            default:
                return;
        }
    };
    const pounceBusinessName = agentData?.business?.businessName || "";

    // Naya business → wahi existing onboarding (business steps), Pounce flow
    // me. Wahan plan + card ke baad agent banta hai.
    const openPounceNewBusiness = () => {
        setShowPounceChoice(false);
        navigate("/business-step", { state: { mode: "new", flow: "pounce" } });
    };

    // Existing business → business steps skip. BusinessStep isi business ko
    // lekar seedha qualifying questions kholta hai, phir plan + card, phir agent.
    // returnTo: wahan Back dabane pe user isi screen pe laut aata hai.
    const openPounceExistingBusiness = () => {
        const biz = agentData?.business || {};
        const agent = agentData?.agent || {};
        setShowPounceChoice(false);
        navigate("/business-step", {
            state: {
                mode: "existing",
                flow: "pounce",
                returnTo: `${location.pathname}${location.search}`,
                business: {
                    businessId: agent.businessId || biz.businessId || "",
                    businessName: biz.businessName || "",
                    googleBusinessName: biz.googleBusinessName || "",
                    businessType: biz.businessType || "",
                    subType: biz.subType || "",
                    webUrl: biz.webUrl || "",
                    googleUrl: biz.googleUrl || "",
                    buisnessEmail: biz.buisnessEmail || "",
                    phone: biz.phone || "",
                    address1: biz.address1 || "",
                    city: biz.city || "",
                    state: biz.state || "",
                    country: biz.country || "",
                    zip: biz.zip || "",
                    country_code: biz.country_code || "",
                    scrapedUrls: biz.scrapedUrls || [],
                    knowledge_base_texts: biz.knowledge_base_texts || {},
                },
                agent: {
                    agentLanguage: agent.agentLanguage || "",
                    agentLanguageCode: agent.agentLanguageCode || "",
                    timezone: agent.timezone || "",
                },
            },
        });
    };

    // console.log(agentData?.agent?.calendarId)
    return (
        <>
            <div>
                <div className={`${styles.navbar} ${hideFooter ? styles.navbarHidden : ""}`}>
                    {/* Home */}
                    <button
                        className={`${styles.tab} ${activeTab === "home" ? styles.active : ""}`}
                        id="tour-footer-home"
                        onClick={() =>
                            handleTabClick(
                                "home",
                                /*
                                 * Multi-agent users get the dashboard
                                 * picker so they can switch between
                                 * their agents. Single-agent users
                                 * stay on /fast-agent-detail — the
                                 * dashboard would just show one card
                                 * for them.
                                 *
                                 * EXCEPTION: admins ALWAYS go to the
                                 * grouped dashboard (even with a single
                                 * agent) — it matches their login-landing
                                 * rule and is where they manage every
                                 * owner's agents.
                                 */
                                adminsAnyCompany || agentCount >= 2
                                    ? "/dashboard"
                                    : "/fast-agent-detail",
                            )
                        }
                        aria-current={activeTab === "home" ? "page" : undefined}
                    >
                        <span className={styles.icon}>
                            {/* same svg */}
                            <svg width="28" height="31" viewBox="0 0 28 31" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M27.0129 12.0915L26.0129 22.735C26.0129 26.7616 22.7184 30.0551 18.6928 30.0551H8.32012C4.29455 30.0551 1 26.7616 1 22.735L0 12.0915C0 10.1557 0.819416 8.49008 2.35197 7.30913L9.82008 1.55335C12.0221 -0.144085 14.9899 -0.144085 17.1918 1.55335L24.66 7.30913C26.1925 8.49008 27.0129 10.1557 27.0129 12.0915ZM8.99055 23.6339C8.57935 23.6339 8.24662 23.3012 8.24662 22.89C8.24662 22.4788 8.57935 22.146 8.99055 22.146H18.0224C18.4336 22.146 18.7663 22.4788 18.7663 22.89C18.7663 23.3012 18.4336 23.6339 18.0224 23.6339H8.99055Z"
                                    fill="#5F33E1"
                                />
                            </svg>
                        </span>
                    </button>

                    {/* Calendar */}
                    <LockOverlay locked={!canViewAppointments}>
                        <button
                            id="tour-footer-calendar"
                            className={`${styles.tab} ${activeTab === "calendar" ? styles.active : ""}`}
                            onClick={() => handleTabClick("calendar", "/calendar")}
                            aria-current={activeTab === "calendar" ? "page" : undefined}
                        >
                            <span className={styles.icon}>
                                {agentData?.agent?.calendarId ?
                                    <svg width="26" height="31" viewBox="0 0 26 31" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                                        <path
                                            d="M25.9997 8.82162V6.1039C26.001 5.20803 25.6546 4.34916 25.0361 3.71493C24.4164 3.08207 23.5771 2.72729 22.7017 2.72866H20.7421V1.09586C20.7421 0.490382 20.2629 0 19.6713 0C19.0796 0 18.6005 0.490382 18.6005 1.09586V2.72866H14.0708V1.09586C14.0708 0.490382 13.5916 0 12.9999 0C12.4083 0 11.9291 0.490382 11.9291 1.09586V2.72866H7.39944V1.09586C7.39944 0.490382 6.92025 0 6.32861 0C5.73696 0 5.25778 0.490382 5.25778 1.09586V2.72866H3.29815C2.42275 2.7273 1.58349 3.08207 0.963748 3.71493C0.345341 4.34916 -0.00133459 5.20803 3.86125e-06 6.1039V8.82162H25.9997Z"
                                            fill="#5F33E1"
                                        />
                                        <path
                                            d="M3.86125e-06 11.0156V26.9604C-0.00133459 27.8563 0.345341 28.7152 0.963748 29.3494C1.58349 29.9822 2.42275 30.337 3.29815 30.3357H22.7015C23.5769 30.337 24.4162 29.9822 25.0359 29.3494C25.6543 28.7152 26.001 27.8563 25.9997 26.9604V11.0156H3.86125e-06Z"
                                            fill="#B5A0F3"
                                        />
                                    </svg> : <svg width="26" height="31" viewBox="0 0 26 31" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                                        <path
                                            d="M25.9997 8.82162V6.1039C26.001 5.20803 25.6546 4.34916 25.0361 3.71493C24.4164 3.08207 23.5771 2.72729 22.7017 2.72866H20.7421V1.09586C20.7421 0.490382 20.2629 0 19.6713 0C19.0796 0 18.6005 0.490382 18.6005 1.09586V2.72866H14.0708V1.09586C14.0708 0.490382 13.5916 0 12.9999 0C12.4083 0 11.9291 0.490382 11.9291 1.09586V2.72866H7.39944V1.09586C7.39944 0.490382 6.92025 0 6.32861 0C5.73696 0 5.25778 0.490382 5.25778 1.09586V2.72866H3.29815C2.42275 2.7273 1.58349 3.08207 0.963748 3.71493C0.345341 4.34916 -0.00133459 5.20803 3.86125e-06 6.1039V8.82162H25.9997Z"
                                            fill="#5F33E1"
                                        />
                                        <path
                                            d="M3.86125e-06 11.0156V26.9604C-0.00133459 27.8563 0.345341 28.7152 0.963748 29.3494C1.58349 29.9822 2.42275 30.337 3.29815 30.3357H22.7015C23.5769 30.337 24.4162 29.9822 25.0359 29.3494C25.6543 28.7152 26.001 27.8563 25.9997 26.9604V11.0156H3.86125e-06Z"
                                            fill="#B5A0F3"
                                        />
                                    </svg>}
                            </span>
                            {agentData?.agent?.calendarId ? <div className={styles.notif1}></div> : <div className={styles.notif2}></div>}
                        </button>
                    </LockOverlay>

                    {/* More */}
                    <div id="tour-footer-more" className={styles.createWrapper} onClick={() => setIsMoreOpen(true)}>
                        <button className={styles.createBtn} aria-label="Create">
                            <span className={styles.createIcon}>
                                <img src="/svg/more_setting.svg" alt="more_setting" />
                            </span>
                            <span className={styles.createText}>More</span>
                        </button>
                    </div>

                    {/* Support / Info */}
                    {/* <button
                    {/* Contacts — owners + admins (of any company) can access;
                        support is locked. Company chosen inside via selector. */}
                    <LockOverlay locked={!canOpenContacts}>
                        {/* <button
                            id="tour-footer-support"
                            className={`${styles.tab} ${activeTab === "info" ? styles.active : ""}`}
                            aria-current={activeTab === "info" ? "page" : undefined}
                            onClick={() => handleTabClick("info", "/totalcall-list")}
                        >
                            <span className={styles.icon}>
                                <img src="svg/Call-handled-icon.svg" alt="Call-handled-icon" />
                            </span>
                        </button> */}
                        <button
                            id="tour-footer-contacts"
                            className={`${styles.tab} ${activeTab === "contacts" ? styles.active : ""}`}
                            aria-current={activeTab === "contacts" ? "page" : undefined}
                            onClick={() => {
                                setActiveTab("contacts");
                                navigate(`/contacts?agentId=${agentData?.agent?.agent_id || ""}`);
                            }}
                        >
                            <span className={styles.icon}>
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                                        stroke="#5F33E1" strokeWidth="2" strokeLinecap="round" fill="none" />
                                    <circle cx="9" cy="7" r="4"
                                        stroke="#B5A0F3" strokeWidth="2" fill="none" />
                                    <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"
                                        stroke="#5F33E1" strokeWidth="2" strokeLinecap="round" fill="none" />
                                </svg>
                            </span>
                        </button>
                        {/* </button> */}
                    </LockOverlay>
                </div>
            </div >

            {/* Modal */}
            < NewModal
                isOpen={isMoreOpen}
                onClose={() => setIsMoreOpen(false)}
                title="More Setting"
                titleAccent
                height="auto"
            >
                <div className={styles.container}>
                    {/* Warna har item par alag lock lagta hai aur Dialer khula rehta hai. */}
                    <LockOverlay locked={lockWholeGrid}>
                        <div className={styles.moreSections}>
                            {!isDashboard && moreSections.map((section) => (
                                <section key={section.key} aria-label={section.title}>
                                    <h4 className={`${styles.moreSectionTitle} ${styles[`moreLine_${section.key}`] || ""}`}>
                                        <MoreSectionIcon kind={section.key} />
                                        <span>{section.title}</span>
                                    </h4>
                                    {/* 3 se zyada items = row scroll hoti hai; tabhi
                                        khulte waqt "scroll hint" wala jhatka chalta hai. */}
                                    {section.key === "products" ? (
                                        // Add-ons: tile nahi, poori chaudai ka row card (icon,
                                        // naam + taaj, ek line ka parichay, teer). Zyada add-ons
                                        // aane par ye layout badlega.
                                        <div className={styles.addonList}>
                                            {section.items.map(({ item }) => {
                                                const locked =
                                                    !lockWholeGrid &&
                                                    !canEditAgents &&
                                                    !EDIT_EXEMPT_ACTIONS.includes(item.action);
                                                return (
                                                    <LockOverlay
                                                        key={item.action}
                                                        locked={locked}
                                                        message="You don't have permission to access this feature."
                                                    >
                                                        <button
                                                            type="button"
                                                            className={styles.addonCard}
                                                            onClick={() => handleOptionClick(item.action)}
                                                        >
                                                            <img className={styles.addonIcon} src={item.icon} alt="" />
                                                            <span className={styles.addonText}>
                                                                <span className={styles.addonTitle}>
                                                                    {item.label}
                                                                    {item.isPremium && (
                                                                        <svg className={styles.addonCrown} width="20" height="20" viewBox="0 0 24 24" aria-label="Premium add-on" role="img">
                                                                            <path d="M3 8l4.5 4L12 5l4.5 7L21 8l-1.5 8h-15L3 8Z" fill="#FBBF24" />
                                                                            <rect x="4.5" y="17.5" width="15" height="2.5" rx="1" fill="#F59E0B" />
                                                                        </svg>
                                                                    )}
                                                                </span>
                                                                {item.subtitle && (
                                                                    <span className={styles.addonSubtitle}>{item.subtitle}</span>
                                                                )}
                                                            </span>
                                                            <svg className={styles.addonChevron} width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                                                <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                        </button>
                                                    </LockOverlay>
                                                );
                                            })}
                                        </div>
                                    ) : (
                                    <div className={`${styles.moreRow} ${section.items.length > 3 ? styles.moreRowHint : ""}`}>
                            {section.items.map(({ item, index }) => {
                                const isTestAgent = item.action === "TEST_AGENT";
                                const shouldBeGray = isTestAgent ? hoveredIndex === null : hoveredIndex === index;
                                const isDriveBtn = item.action === "CONNECT_DRIVE";
                                const isDriveLoading = isDriveBtn && driveLoading;
                                const isSetupScore = item.action === "SETUP_SCORE";
                                const isDriveGated =
                                    isDriveLocked && DRIVE_GATED_ACTIONS.includes(item.action);
                                const isPlanGated =
                                    isMobileFree && PLAN_GATED_ACTIONS.includes(item.action);
                                const isNumberGated =
                                    !_hasAssignedNumber && NUMBER_GATED_ACTIONS.includes(item.action);
                                // Grid par pehle se taala ho to item par dobara mat lagao.
                                const isEditGated =
                                    !lockWholeGrid &&
                                    !canEditAgents &&
                                    !EDIT_EXEMPT_ACTIONS.includes(item.action);
                                // Subscription already cancelled → the entry stays
                                // visible but is not actionable a second time.
                                const isCancelGated =
                                    cancelSubscriptionLocked &&
                                    item.action === "CANCEL_SUBSCRIPTION";
                                const isItemLocked = isDriveGated || isPlanGated || isNumberGated || isCancelGated || isEditGated;
                                return (
                                    <LockOverlay
                                        key={index}
                                        locked={isItemLocked}
                                        message={
                                            isCancelGated
                                                ? cancelSubscriptionLockMessage
                                                : isNumberGated
                                                    ? "Assign a phone number to unlock this feature."
                                                : isPlanGated
                                                    ? "Upgrade your plan to unlock this feature."
                                                : isDriveGated
                                                    ? driveLockMessage
                                                    : "You don't have permission to access this feature."
                                        }
                                    >
                                    <div
                                        className={`${styles.item} ${shouldBeGray ? styles.grayBg : ""}`}
                                        onMouseEnter={() => setHoveredIndex(index)}
                                        onMouseLeave={() => setHoveredIndex(null)}
                                        // onClick={() => handleOptionClick(item.action)}
                                        onClick={() => !isDriveLoading && handleOptionClick(item.action)}
                                        role="button"
                                        tabIndex={0}
                                        // style={{ cursor: "pointer" }}
                                        style={{ cursor: isDriveLoading ? "not-allowed" : "pointer", opacity: isDriveLoading ? 0.6 : 1 }}
                                        onKeyDown={(e) =>
                                            // (e.key === "Enter" || e.key === " ") && handleOptionClick(item.action)
                                            (e.key === "Enter" || e.key === " ") && !isDriveLoading && handleOptionClick(item.action)
                                        }
                                    >
                                        {/*
                                        <div className={styles.iconWrap}>
                                            <img src={item.icon} alt={item.label} />
                                            {item.isNew && <span className={styles.newTag}>New</span>}
                                        </div>
                                        <p>{item.label}</p>
                                        </div>
                                        */}
                                        <div className={styles.iconWrap}>
                                            {isSetupScore ? (
                                                <SetupProgressRing
                                                    percent={setupScorePercent}
                                                    size={38}
                                                    stroke={3}
                                                    compact
                                                />
                                            ) : isDriveBtn && isDriveLoading ? (
                                                <div className={styles.spinner} />
                                            ) : (
                                                <>
                                                    <img
                                                        src={item.icon}
                                                        alt={item.label}
                                                        className={item.action === "POUNCE" ? styles.pounceIcon : undefined}
                                                    />
                                                    {item.isDriveConnected && (
                                                        <span className={styles.connectedDot} title="Drive Connected" />
                                                    )}
                                                    {item.isNew && <span className={styles.newTag}>New</span>}
                                                    {item.isPremium && (
                                                        <span className={styles.crownTag} title="Premium add-on">
                                                            <svg width="12" height="12" viewBox="0 0 24 24" fill="#fff" aria-hidden="true">
                                                                <path d="M3 8l4.500 4L12 5l4.500 7L21 8l-1.800 10H4.800L3 8Z" />
                                                            </svg>
                                                        </span>
                                                    )}
                                                    {item.statusTag && (
                                                        <span className={`${styles.statusTag} ${styles[item.statusType]}`}>
                                                            {item.statusTag}
                                                        </span>
                                                    )}
                                                </>
                                            )}
                                        </div>

                                        <p className={isSetupScore ? styles.setupScoreLabel : undefined}>
                                            {isDriveLoading ? "Connecting..." : item.label}
                                        </p>

                                    </div>
                                    </LockOverlay>
                                );
                            })}
                                    </div>
                                    )}
                                </section>
                            ))}

                            {/* Create New Agent */}
                            {/* <div className={styles.createCard}
                            onClick={() => {
                                navigate('/fork', { state: { mode: "new" } })
                            }}
                        >
                            <img src="/svg/plus_icon_new.svg" alt="plus_icon_new" />
                            <p>Create New Agent</p>
                        </div> */}
                        </div>
                    </LockOverlay>
                </div>
            </NewModal >

            <NewModal
                isOpen={showPounceChoice}
                onClose={() => setShowPounceChoice(false)}
                title="Set up Outbound Caller"
                height="auto"
            >
                <p className={styles.pounceIntro}>
                    Outbound Caller calls every new lead within 10 seconds. Which business should it call for?
                </p>
                <div className={styles.pounceChoiceList}>
                    <button
                        type="button"
                        className={styles.pounceChoice}
                        onClick={openPounceExistingBusiness}
                    >
                        <span className={styles.pounceChoiceText}>
                            <span className={styles.pounceChoiceTitle}>Use existing business details</span>
                            <span className={styles.pounceChoiceDesc}>
                                {pounceBusinessName
                                    ? `Continue with ${pounceBusinessName}`
                                    : "Use current business details"}
                            </span>
                        </span>
                        <img src="/svg/setup_arrow_icon.svg" alt="" aria-hidden="true" />
                    </button>
                    <button
                        type="button"
                        className={styles.pounceChoice}
                        onClick={openPounceNewBusiness}
                    >
                        <span className={styles.pounceChoiceText}>
                            <span className={styles.pounceChoiceTitle}>Add new business details</span>
                            <span className={styles.pounceChoiceDesc}>Set up Outbound Caller for a different business</span>
                        </span>
                        <img src="/svg/setup_arrow_icon.svg" alt="" aria-hidden="true" />
                    </button>
                </div>
            </NewModal>

            <ConfirmModal
                show={showDisconnectConfirm}
                onClose={() => !driveLoading && setShowDisconnectConfirm(false)}
                title="Disconnect Drive?"
                message="Are you sure you want to disconnect Google Drive? You will need to reconnect to continue uploading files."
                type="info"
                onConfirm={handleDisconnectDrive}
                confirmText="Disconnect"
                cancelText="Cancel"
                showCancel={true}
                isLoading={driveLoading}
            />
        </>
    );
};

export default FooterNew;
